import { LABELS } from '@/constants/common/message.constants'

import { type TariffListExEntity } from '../../aspida/@types'

/**
 * タリフ種別
 */
export type TariffType = TariffListExEntity['tariffType']

export const TARIFF_TYPE = {
  /** 運賃区分 */
  CHARGE_TYPE: 'CHARGE_TYPE',
  /** 重量 */
  WEIGHT: 'WEIGHT',
  /** 車格・車両属性 */
  TRUCK_CLASS_AND_TYPE: 'TRUCK_CLASS_AND_TYPE'
} as const satisfies Record<TariffType, TariffType>

export const TARIFF_TYPE_LABEL = {
  [TARIFF_TYPE.CHARGE_TYPE]: LABELS.CHARGE_TYPE,
  [TARIFF_TYPE.WEIGHT]: LABELS.TARIFF_TYPE_WEIGHT,
  [TARIFF_TYPE.TRUCK_CLASS_AND_TYPE]: LABELS.TARIFF_TYPE_TRUCK_CLASS_AND_TYPE
} as const satisfies Record<TariffType, string>
